module.exports = __webpack_public_path__ + "static/img/wu.eba21c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/check/wu.jpg
// module id = 30+6
// module chunks = 1